/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Limit} from '../models/Limit';

export interface GetAccountMcpLimits$Request {
    accountId: number;
}

export interface GetAccountMcpLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountMcpLimitsRequest = createAction<PayloadData<void, GetAccountMcpLimits$Request>>('ACCOUNT_MCP_LIMITS__GET_ACCOUNT_MCP_LIMITS__REQUEST');
export const getAccountMcpLimitsSuccess = createAction<PayloadData<Array<Limit>, GetAccountMcpLimits$Request>>('ACCOUNT_MCP_LIMITS__GET_ACCOUNT_MCP_LIMITS__SUCCESS');
export const getAccountMcpLimitsFailure = createAction<PayloadData<Error, GetAccountMcpLimits$Request, true>>('ACCOUNT_MCP_LIMITS__GET_ACCOUNT_MCP_LIMITS__FAILURE');

export const getAccountMcpLimitsActions = [
    getAccountMcpLimitsRequest,
    getAccountMcpLimitsSuccess,
    getAccountMcpLimitsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountMcpLimits = (meta: GetAccountMcpLimits$Request, config?: GetAccountMcpLimits$Config) => {
    return {
        CALL_API: {
            types: getAccountMcpLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/mcp/limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveAccountMcpLimits$Request {
    accountId: number;
    limit: Array<Limit>;
}

export interface SaveAccountMcpLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveAccountMcpLimitsRequest = createAction<PayloadData<void, SaveAccountMcpLimits$Request>>('ACCOUNT_MCP_LIMITS__SAVE_ACCOUNT_MCP_LIMITS__REQUEST');
export const saveAccountMcpLimitsSuccess = createAction<PayloadData<void, SaveAccountMcpLimits$Request>>('ACCOUNT_MCP_LIMITS__SAVE_ACCOUNT_MCP_LIMITS__SUCCESS');
export const saveAccountMcpLimitsFailure = createAction<PayloadData<Error, SaveAccountMcpLimits$Request, true>>('ACCOUNT_MCP_LIMITS__SAVE_ACCOUNT_MCP_LIMITS__FAILURE');

export const saveAccountMcpLimitsActions = [
    saveAccountMcpLimitsRequest,
    saveAccountMcpLimitsSuccess,
    saveAccountMcpLimitsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {Array<Limit>} meta.limit
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveAccountMcpLimits = (meta: SaveAccountMcpLimits$Request, config?: SaveAccountMcpLimits$Config) => {
    return {
        CALL_API: {
            types: saveAccountMcpLimitsActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/accounts/${meta.accountId}/mcp/limits`,
            TRANSPORT_REQUEST_BODY: meta.limit,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

